<script>
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'
import FormattingHelpers from '@/mixins/FormattingHelpers'

export default {
  components: {
    'mia-feature-select': FeatureSelect
  },

  mixins: [FormattingHelpers],

  props: {
    categories: {
      type: Array,
      required: true
    }
  },

  computed: {
    absenceCategory() {
      return this.$store.state.service.filters.global.absenceCategory
    }
  },

  methods: {
    onInput(absenceCategory) {
      console.log('on input', absenceCategory)
    }
  }
}
</script>

<template>
  <mia-feature-select
    :value="absenceCategory"
    v-bind="$attrs"
    label="Kategorie"
    :options="categories"
    :name-by="(category) => formatAsTitleCase(category.absence_category_description)"
    track-by="id"
    @input="onInput"
    v-on="$listeners"
  />
</template>
